import React from 'react';
import { motion } from 'framer-motion';
import { Cloud, Server, Lock, ArrowRightLeft } from 'lucide-react';
import Container from '../../layout/Container';
import SectionHeading from '../../common/SectionHeading';
import Button from '../../common/Button';

const CloudSolutions = () => {
  return (
    <section className="py-20 bg-blue-900 text-white">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <SectionHeading
              title="Scalable Cloud Solutions"
              subtitle="Flexible, reliable, and secure cloud infrastructure for modern businesses."
              light
            />
            
            <p className="text-blue-200 mb-8">
              As businesses increasingly move their operations to the cloud, having a reliable and 
              scalable cloud infrastructure becomes essential. Our cloud solutions are designed to 
              provide you with the flexibility, security, and performance needed to support your 
              business applications and data management requirements.
            </p>
            
            <Button 
              to="/contact" 
              variant="secondary"
              className="mt-4"
            >
              Discuss Your Cloud Needs
            </Button>
          </motion.div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-blue-800 p-6 rounded-lg"
            >
              <div className="text-blue-400 mb-4">
                <Cloud size={32} />
              </div>
              <h3 className="text-xl font-bold mb-3">Cloud Migration</h3>
              <p className="text-blue-200 text-sm">
                Seamless migration of your applications and data to the cloud with minimal disruption to your operations.
              </p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-blue-800 p-6 rounded-lg"
            >
              <div className="text-blue-400 mb-4">
                <Server size={32} />
              </div>
              <h3 className="text-xl font-bold mb-3">Hybrid Solutions</h3>
              <p className="text-blue-200 text-sm">
                Integrating on-premises infrastructure with cloud services to create a balanced and efficient IT environment.
              </p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              className="bg-blue-800 p-6 rounded-lg"
            >
              <div className="text-blue-400 mb-4">
                <Lock size={32} />
              </div>
              <h3 className="text-xl font-bold mb-3">Cloud Security</h3>
              <p className="text-blue-200 text-sm">
                Robust security measures to protect your cloud environment from unauthorized access and data breaches.
              </p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-blue-800 p-6 rounded-lg"
            >
              <div className="text-blue-400 mb-4">
                <ArrowRightLeft size={32} />
              </div>
              <h3 className="text-xl font-bold mb-3">Cloud Management</h3>
              <p className="text-blue-200 text-sm">
                Ongoing monitoring and management of your cloud resources to ensure optimal performance and cost-efficiency.
              </p>
            </motion.div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CloudSolutions;